import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork"; 
import { FetchResultType } from "../fetchTypes";
export const getOrderSummaries = createAsyncThunk(
  "/orderSummaries/get",
  async (params:any, { rejectWithValue }) => {
    try {
      const { data, errorMessage, isSuccess } = await commonNetwork.get("/dashboard/order-summaries/", params);
      if (isSuccess ) {
        return data;
      } else {
        return rejectWithValue(data);
      }
    } catch (e: any) {
      return rejectWithValue(e.data.message);
    }
  }
);

export type OrderSummariesVp={
  vpId: number,
  vpDisplayName:string,
  amount: string,
  bankImagePath: string
}
export type OrderSummaries={
  vpValues: Array<OrderSummariesVp>
}

export interface OrderSummariesStateType extends FetchResultType {
  orderSummaries: Array<OrderSummaries>
}

export const orderSummariesSlice = createSlice({
  name: "orderSummaries",
  initialState: {
    orderSummaries: [],
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: "",
  },
  reducers: {
    clearState: (state) => {
      state.orderSummaries = [];
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getOrderSummaries.fulfilled, (state, { payload }) => {
      state.orderSummaries = payload;
      state.isFetching = false;
      state.isSuccess = true;
      state.isError = false;
      return state;
    });
    builder.addCase(getOrderSummaries.rejected, (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
    });
    builder.addCase(getOrderSummaries.pending, (state) => {
      state.isFetching = true;
    });
  },
});
export const { clearState } = orderSummariesSlice.actions;

export const orderSummariesSelector = (state:any) => state.orderSummaries;

export const orderSummariesReducer = orderSummariesSlice.reducer;
